module.exports = __webpack_public_path__ + "img/image_3.9486781d.png";